import ApiService from "../ApiService";
// &searchString=${searchString}

const ShippinFee = {
    
    search(page, PerPage, searchShippin){
        return ApiService.get(`/provider-schedule-range/search/by/?page=${page}&perPage=${PerPage}&searchString=${searchShippin}`)
    },
    
    creategetShippinFee(formData) {
        return ApiService.post("/provider-schedule-range", formData);
    },
    updategetShippinFee(id, formData) {
        return ApiService.put("/provider-schedule-range/" + id, formData);
    },
    deleteShippinFee(id) {
        return ApiService.post("/provider-schedule-range/remove", id)
    },
    searchShippinFee(name) {
        return ApiService.post(`/provider-schedule-range/searchby?name=${name}`)
    }
};

export default ShippinFee;